import { initializeProgressBar } from '@avalara/bat-apps-shared/client/actions/progress-bar';

import { Pages } from '../../../../types/offers';

import type { Dispatch, ThunkAction } from '@avalara/types/actions';
import type { State } from '@avalara/types/reducer-states';

export const stepNames = {
  companyDetails: 'Company details',
  createYourAccount: 'Create your account',
  nameAndEmail: 'Name and email',
  paymentMethod: 'Payment method',
  reviewAndBuy: 'Review and buy',
  reviewOrder: 'Review order',
  selectPlan: 'Select a plan',
  selectConnector: 'Select a connector',
};

export const initializeOfferProgressBar = (): ThunkAction => (dispatch: Dispatch, getState: () => State) => {
  const {
    account: { isLoggedIn },
    offer: { initializeNewAccounts, pages },
    order: { planSelectComplete },
  } = getState();

  const needToSelectPlan = !planSelectComplete;
  const steps = [];

  if (pages.includes(Pages.Plans)) {
    steps.push({ label: stepNames.selectPlan, active: needToSelectPlan });
  }

  if (pages.includes(Pages.Company)) {
    steps.push({
      label: initializeNewAccounts ? stepNames.createYourAccount : stepNames.nameAndEmail,
      active: !needToSelectPlan,
    });
    steps.push({ label: stepNames.companyDetails });
  }
  if (pages.includes(Pages.SelectConnector)) {
    steps.push({ label: stepNames.selectConnector });
  }
  if (pages.includes(Pages.Payment)) {
    steps.push({ label: stepNames.paymentMethod, active: isLoggedIn && !needToSelectPlan });
  }
  if (pages.includes(Pages.ReviewOrder)) {
    steps.push({ label: stepNames.reviewOrder, active: isLoggedIn && !needToSelectPlan });
  }
  if (pages.includes(Pages.Summary)) {
    steps.push({ label: stepNames.reviewAndBuy });
  }

  dispatch(initializeProgressBar(steps));
};

export const initializeReturnsProgressBar = (): ThunkAction => (dispatch: Dispatch, getState: () => State) => {
  const {
    system: { activeFlow },
  } = getState();
  const isTrial = /trial/.test(activeFlow || '');

  const steps = [
    {
      label: stepNames.nameAndEmail,
      active: true,
    },
    {
      label: stepNames.companyDetails,
    },
  ];

  if (!isTrial) steps.push({ label: stepNames.paymentMethod });
  dispatch(initializeProgressBar(steps));
};
